module.exports = {
	"ha": "iha",
	"id": 5.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category and MSM Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.83333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 79.16666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.83333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.83333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 45.83333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.7741935483871,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#043f61"
					},
					{
						"y": 93.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.09677419354838,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.64516129032258,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#09472e"
					},
					{
						"y": 70.96774193548387,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.26470588235294,
						"dataLabels": {
							"enabled": false,
							"format": "135"
						},
						"color": "#043f61"
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.29411764705883,
						"dataLabels": {
							"enabled": false,
							"format": "116"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.14705882352942,
						"dataLabels": {
							"enabled": false,
							"format": "109"
						},
						"color": "#09472e"
					},
					{
						"y": 61.76470588235294,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.95238095238095,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 61.904761904761905,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 76.59574468085107,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.2127659574468,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 61.702127659574465,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 36.17021276595745,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.37888198757764,
						"dataLabels": {
							"enabled": false,
							"format": "160"
						},
						"color": "#043f61"
					},
					{
						"y": 83.22981366459628,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.12422360248446,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.29192546583852,
						"dataLabels": {
							"enabled": false,
							"format": "118"
						},
						"color": "#09472e"
					},
					{
						"y": 60.86956521739131,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0c4250"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0d4440"
					},
					{
						"y": 46.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#09472e"
					},
					{
						"y": 26.666666666666668,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 72,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0c4250"
					},
					{
						"y": 68,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0d4440"
					},
					{
						"y": 44,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#09472e"
					},
					{
						"y": 44,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.24561403508771,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#043f61"
					},
					{
						"y": 64.91228070175438,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0c4250"
					},
					{
						"y": 59.64912280701754,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 50.877192982456144,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 31.57894736842105,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#043f61"
					},
					{
						"y": 73.27586206896551,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0c4250"
					},
					{
						"y": 69.82758620689656,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.10344827586206,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.1666666666666625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.391304347826086,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.29411764705882,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2258064516129004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.4074074074074066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.7352941176470562,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.034482758620685,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.935779816513758,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.529411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.404255319148938,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.121212121212121,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.379310344827594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.6211180124223614,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.249999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.731343283582089,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.527131782945741,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.94915254237288,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -26.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.29411764705882,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.7543859649122862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.92857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.108108108108103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.93103448275862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.10714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.705882352941182,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4691358024691357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.582278481012654,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=13"
			},
			{
				"x": 9,
				"text": "30-39<br>n=24"
			},
			{
				"x": 15,
				"text": "40-49<br>n=31"
			},
			{
				"x": 21,
				"text": ">=50<br>n=136"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=6"
			},
			{
				"x": 34,
				"text": "30-39<br>n=21"
			},
			{
				"x": 40,
				"text": "40-49<br>n=47"
			},
			{
				"x": 46,
				"text": ">=50<br>n=161"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=15"
			},
			{
				"x": 59,
				"text": "30-39<br>n=25"
			},
			{
				"x": 65,
				"text": "40-49<br>n=57"
			},
			{
				"x": 71,
				"text": ">=50<br>n=116"
			}
		],
		"dataTable": {
			"MSM:<30": [
				13,
				12,
				10,
				10,
				10,
				9
			],
			"MSM:30-39": [
				24,
				23,
				19,
				17,
				17,
				11
			],
			"MSM:40-49": [
				31,
				30,
				29,
				27,
				25,
				22
			],
			"MSM:>=50": [
				136,
				135,
				120,
				116,
				109,
				84
			],
			"Non-MSM:<30": [
				6,
				6,
				4,
				4,
				4,
				2
			],
			"Non-MSM:30-39": [
				21,
				21,
				21,
				19,
				17,
				13
			],
			"Non-MSM:40-49": [
				47,
				47,
				36,
				33,
				29,
				17
			],
			"Non-MSM:>=50": [
				161,
				160,
				134,
				129,
				118,
				98
			],
			"Unknown:<30": [
				15,
				11,
				8,
				8,
				7,
				4
			],
			"Unknown:30-39": [
				25,
				23,
				18,
				17,
				11,
				11
			],
			"Unknown:40-49": [
				57,
				56,
				37,
				34,
				29,
				18
			],
			"Unknown:>=50": [
				116,
				112,
				85,
				81,
				79,
				58
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_5.json
// module id = 237
// module chunks = 0